// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeleteWorkbookMutationVariables = Types.Exact<{
  workbookId: Types.Scalars["ID"]["input"];
}>;

export type DeleteWorkbookMutation = {
  __typename?: "Mutation";
  deleteWorkbook: { __typename?: "DeleteWorkbookPayload"; databaseId: string };
};

export const DeleteWorkbookDocument = gql`
  mutation DeleteWorkbook($workbookId: ID!) {
    deleteWorkbook(workbookId: $workbookId) {
      databaseId
    }
  }
`;
export type DeleteWorkbookMutationFn = Apollo.MutationFunction<
  DeleteWorkbookMutation,
  DeleteWorkbookMutationVariables
>;

/**
 * __useDeleteWorkbookMutation__
 *
 * To run a mutation, you first call `useDeleteWorkbookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkbookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkbookMutation, { data, loading, error }] = useDeleteWorkbookMutation({
 *   variables: {
 *      workbookId: // value for 'workbookId'
 *   },
 * });
 */
export function useDeleteWorkbookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWorkbookMutation,
    DeleteWorkbookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteWorkbookMutation,
    DeleteWorkbookMutationVariables
  >(DeleteWorkbookDocument, options);
}
export type DeleteWorkbookMutationHookResult = ReturnType<
  typeof useDeleteWorkbookMutation
>;
export type DeleteWorkbookMutationResult =
  Apollo.MutationResult<DeleteWorkbookMutation>;
export type DeleteWorkbookMutationOptions = Apollo.BaseMutationOptions<
  DeleteWorkbookMutation,
  DeleteWorkbookMutationVariables
>;
